<!-- 
System: GIGSTIMER
Developer(s): Fatima Saeed, Jazib Nasir
Date: --/--/--
Organization: Programmers Force
Purpose: Stripe Payment Process and Invoice Listing
-->
<template>
  <div>
    <v-row :class="$vuetify.breakpoint.smAndDown ? 'mt-7' : 'mx-15 mt-4'">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-card
          height="100px"
          class="d-flex align-center"
          :class="$vuetify.breakpoint.xs ? 'elevation-0' : ''"
        >
          <v-row class="px-9 d-flex align-center">
            <v-col cols="12" lg="5" sm="6" md="5" xl="8">
              <v-row>
                <!-- Stripe Plan -->
                <div class="d-flex align-center">Your Selected Plan is :</div>
                <v-chip
                  class="ml-2 text-capitalize"
                  style="color: #8e6a01"
                  color="#f5e9b7"
                  >{{
                    getSelectedCompany.subscribed_plan &&
                    getSelectedCompany.subscribed_plan.replace(/_/g, " ")
                  }}
                </v-chip>
              </v-row>
            </v-col>
            <v-col cols="12" sm="6" lg="7" md="7" xl="4">
              <v-row
                :class="
                  $vuetify.breakpoint.mdAndDown
                    ? 'justify-center'
                    : 'float-right'
                "
              >
                <!-- Button for Update Plan -->
                <v-btn
                  :class="$vuetify.breakpoint.mdAndDown ? 'mt-2' : ''"
                  dark
                  color="#94dece"
                  style="color: #1d4038"
                  class="mr-2"
                  @click="changePlan()"
                  >Update Plan</v-btn
                >
                <!-- Button for Cancel Subscription -->
                <v-btn
                  :class="$vuetify.breakpoint.mdAndDown ? 'mt-2' : ''"
                  color="error"
                  @click="cancelAndDeleteCards"
                  >Cancel Subscription</v-btn
                >
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row :class="$vuetify.breakpoint.smAndDown ? 'mt-12' : 'mx-15 mt-4'">
      <v-col cols="12" sm="12" md="12" lg="12" xl="12">
        <v-card min-height="50px" class="w-100">
          <v-row height="50px" class="d-flex justify-center text-bold">
            <v-card-title class="text-center my-2">Payment Method</v-card-title>
            <v-card-text class="text-center"
              >The first card that you add will become the default card and
              cannot be deleted. You have to enter card separately for all the
              companies that you create.</v-card-text
            >
          </v-row>
          <v-row
            :class="
              $vuetify.breakpoint.mdAndDown ? 'mx-1 mt-12' : 'mx-15 mt-12'
            "
          >
            <v-col cols="12" sm="6" md="6" lg="4" xl="4">
              <!-- Card for Adding new credit card -->
              <v-card
                @click="openCreditCardDialog()"
                height="140px"
                class="
                  d-flex
                  align-center
                  justify-center
                  rounded-card
                  elevation-4
                  mb-3
                "
              >
                <v-icon
                  :class="$vuetify.breakpoint.xs ? 'ml-2' : ''"
                  color="#2a206a"
                  >mdi-plus-circle</v-icon
                >
                <span class="ml-4">Add new Default Credit Card</span>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="4"
              xl="4"
              v-for="(card, index) in getCompanyCards"
              :key="index"
            >
              <!-- Card listing Card Starts-->
              <v-card
                height="140px"
                class="elevation-4 mb-3 pa-1"
                @mouseover="hoverOnList = card.card_id"
                @mouseleave="hoverOnList = ''"
              >
                <div
                  :class="card.brand"
                  class="
                    card-title
                    text-center text-capitalize
                    font-weight-bold
                    text-white
                  "
                >
                  <img
                    :src="imgSource"
                    height="50"
                    width="100px"
                    v-if="card.brand === 'amex'"
                  />
                  <img
                    height="50px"
                    :width="$vuetify.breakpoint.mdAndDown ? '190px' : '250px'"
                    :src="imgSourceCap1"
                    v-else-if="card.brand === 'capital_one'"
                  />
                  <img
                    height="50px"
                    :width="$vuetify.breakpoint.mdAndDown ? '190px' : '250px'"
                    :src="imgSourceCiti"
                    v-else-if="card.brand === 'citi'"
                  />
                  <img
                    height="50px"
                    :width="$vuetify.breakpoint.mdAndDown ? '190px' : '250px'"
                    :src="imgSourceDiner"
                    v-else-if="card.brand === 'diners'"
                  />
                  <img
                    height="50px"
                    :width="$vuetify.breakpoint.mdAndDown ? '190px' : '250px'"
                    :src="imgSourceDiscover"
                    v-else-if="card.brand === 'discover'"
                  />
                  <img :src="imgSourceJcb" v-else-if="card.brand === 'jcb'" />
                  <img
                    height="50"
                    :width="$vuetify.breakpoint.mdAndDown ? '70px' : '100px'"
                    :src="imgSourceMaster"
                    v-else-if="card.brand === 'mastercard'"
                  />
                  <img
                    height="50px"
                    :width="$vuetify.breakpoint.mdAndDown ? '190px' : '250px'"
                    :src="imgSourceUnionPay"
                    v-else-if="card.brand === 'unionpay'"
                  />
                  <img
                    height="50px"
                    :width="$vuetify.breakpoint.mdAndDown ? '190px' : '250px'"
                    :src="imgSourceVisa"
                    v-else-if="card.brand === 'visa'"
                  />
                  <img :src="imgSourceUK" v-else />
                  <div class="card-setting d-flex flex-row">
                    <span
                      @click="defaultCard(card)"
                      v-if="
                        card.default_payment_method == false &&
                        hoverOnList == card.card_id
                      "
                      style="cursor: pointer"
                      class="ImgHeader pa-1 ml-1 mt-1"
                      >Make Default</span
                    >
                    <span
                      v-if="card.default_payment_method == true"
                      class="ImgHeader ml-1 mt-1 pa-1"
                      >Default</span
                    >
                    <v-spacer></v-spacer>
                    <span class="float-right">
                      <v-icon
                        v-if="
                          card.default_payment_method == false &&
                          hoverOnList == card.card_id
                        "
                        @click="deleteCard(card)"
                        small
                        class="float-right mr-2 mt-2"
                        color="white"
                        >mdi-trash-can</v-icon
                      >
                    </span>
                  </div>
                </div>

                <div class="d-flex align-center justify-center">
                  <div class="d-flex align-center justify-center pt-2">
                    <span class="mr-2 spanClass">**** **** **** </span>
                    {{ card.last4 }}
                  </div>
                </div>
              </v-card>
              <!-- Card listing Card End-->
            </v-col>
          </v-row>
          <v-row height="50px" class="d-flex justify-center text-bold my-5">
            <!-- Title and Subtitle of Invoice Listing -->
            <v-card-title class="text-center">Invoices History</v-card-title>
            <v-card-text class="text-center"
              >You can download your invoices history and save it to your
              device.</v-card-text
            >
          </v-row>
          <!-- Data Table for invoice Listing -->
          <v-data-table
            :headers="headers"
            hide-default-footer
            :items="getInvoiceListing"
            class="elevation-1 mt-10 mb-2"
          >
            <template v-slot:[`item.paid`]="{ item }">
              <div
                class="text-capitalize"
                :class="item.paid ? '' : 'caption grey--text font-italic'"
              >
                {{ item.paid === null ? "No Data" : item.paid }}
              </div>
            </template>
            <template v-slot:[`item.start`]="{ item }">
              <div
                class="text-capitalize"
                :class="item.start ? '' : 'caption grey--text font-italic'"
              >
                {{ item.start === null ? "No Data" : item.start }}
              </div>
            </template>
            <template v-slot:[`item.end`]="{ item }">
              <div
                class="text-capitalize"
                :class="item.end ? '' : 'caption grey--text font-italic'"
              >
                {{ item.end === null ? "No Data" : item.end }}
              </div>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                label
                :color="item.status == 'paid' ? 'success' : 'error'"
                class="text-capitalize white--text"
                :class="item.status ? '' : 'caption white--text font-italic '"
              >
                {{ item.status === null ? "No Data" : item.status }}
              </v-chip>
            </template>
            <template v-slot:[`item.pdf`]="{ item }">
              <a :href="item.pdf" target="_blank">
                <v-chip
                  outlined
                  label
                  color="success"
                  class="text-capitalize white--text"
                  :class="item.pdf ? '' : 'caption white--text font-italic '"
                >
                  Download Invoice
                </v-chip>
              </a>
            </template>
            <template v-slot:[`item.id`]="{ item }">
              <v-tooltip color="#66BB6A" top>
                <template v-slot:activator="{ on }">
                  <div
                    class="text-capitalize"
                    v-on="on"
                    :class="item.id ? '' : 'caption grey--text font-italic'"
                  >
                    {{
                      item.id === null
                        ? "No Data"
                        : item.id.substring(0, 12) + "..."
                    }}
                  </div>
                </template>
                <span class="text-capitalize">{{ item.id }}</span>
              </v-tooltip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <!-- Snack bar  -->
    <div>
      <SnackbarNew
        :snackbar.sync="snackbar"
        :snackbarError="snackbarError"
        :snackbarMessage="snackbarMessage"
      />
    </div>
  </div>
</template>

<script>
import PaymentMethodMixin from "@/components/Payment/PaymentMethodMixin";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import { eventBus } from "@/main";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  data() {
    //Publish Key of stripe
    this.publishableKey = process.env.VUE_APP_STRIPE_KEY;
    return {
      // Here we define variables which we use in conditional rendering
      option: {
        plan: null,
        product: null,
        amount: 0,
      },
      hoverOnList: false,
      // img sources for cards icons
      imgSource: require("@/assets/svgs/american_express.png"),
      imgSourceCap1: require("@/assets/svgs/capital_one.svg"),
      imgSourceCiti: require("@/assets/svgs/citi.svg"),
      imgSourceDiner: require("@/assets/svgs/diners_club.svg"),
      imgSourceDiscover: require("@/assets/svgs/discover.svg"),
      imgSourceJcb: require("@/assets/svgs/jcb.svg"),
      imgSourceMaster: require("@/assets/svgs/master.svg"),
      imgSourceUnionPay: require("@/assets/svgs/union_pay.svg"),
      imgSourceUK: require("@/assets/svgs/unknown_card.svg"),
      imgSourceVisa: require("@/assets/svgs/visa.svg"),
      // Headers for table
      headers: [
        {
          text: "Invoice Name",
          align: "start",
          value: "id",
          class: " px-3",
          width: "12vw",
          sortable: true,
        },
        {
          text: "Invoice Date",
          value: "created_at",
          class: " px-3",
          align: "start",
          width: "10vw",
          sortable: false,
        },
        {
          text: "From",
          value: "start",
          class: " px-3",
          align: "start",
          sortable: false,
          width: "12vw",
        },
        {
          text: "To",
          value: "end",
          class: " px-3",
          align: "start",
          sortable: false,
          width: "12vw",
        },
        {
          text: "Price",
          value: "paid",
          class: " px-3",
          align: "start",
          sortable: false,
          width: "12vw",
        },
        {
          text: "Status",
          value: "status",
          class: " px-3",
          align: "start",
          sortable: false,
          width: "10vw",
        },
        {
          text: "Download",
          value: "pdf",
          class: " px-3",
          align: "start",
          width: "10vw",
          sortable: false,
        },
      ],
    };
  },
  mixins: [PaymentMethodMixin, snackbarMixin],
  components: {
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
  },
  computed: {
    ...mapGetters([
      "getSelectedCompany",
      "getCompanyCards",
      "getInvoiceListing",
    ]),
  },
  mounted() {
    this.cardListing();
    this.stripeInvoiceListing();
  },
  methods: {
    // Function for Credit Card Getting Information Dialog
    openCreditCardDialog() {
      eventBus.$emit("openCreditCardModal", true);
    },
    // Function for plan updation
    changePlan() {
      eventBus.$emit("updatePlan", true);
    },
    // In this function we make selected card default
    defaultCard(card) {
      let data = {
        company_id: this.getSelectedCompany.id,
        card_id: card.card_id,
      };
      // Dialog for Make card default
      Swal.fire({
        title: "Make Card Default",
        html: "Are you sure you want to make this card default ?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonText: "Yes",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("defaultCard", data).then((response) => {
            if (response.status == 200) {
              this.openSnackbar(false, response.data.message);
            }
            this.cardListing();
          });
        }
      });
    },
    // In this function we delete selected card
    deleteCard(card) {
      let data = {
        company_id: this.getSelectedCompany.id,
        card_id: card.card_id,
      };
      // Dialog for delete card
      Swal.fire({
        title: "Delete Card",
        html: "Are you sure you want to delete card?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Delete",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("deleteCard", data)
            .then((response) => {
              if (response.status == 200) {
                this.openSnackbar(false, response.data.message);
                this.cardListing();
              }
            })
            .catch((err) => {
              if (err.response.status == 422) {
                this.openSnackbar(true, err.response.data.message);
              }
              if (err.response.status == 403) {
                this.openSnackbar(true, err.response.data.message);
              }
            });
        }
      });
    },
    // In this function we cancel all subscriptions and delete all cards
    cancelAndDeleteCards() {
      let data = {
        company_id: this.getSelectedCompany.id,
      };
      // Dialog for cancel subscription
      Swal.fire({
        title: "Cancel Subcription",
        html: "Are you sure you want to Cancel Subscription?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancel",
        confirmButtonText: "Ok",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("cancelAndDeleteCards", data)
            .then((response) => {
              if (response.status == 200) {
                this.$store.commit("setCompanyCardsList", []);
                this.$store.commit("setInvoiceListing", []);

                this.openSnackbar(false, response.data.message);
                this.$store
                  .dispatch("fetchAllCompaniesList")
                  .then((response) => {
                    if (response.status == 200) {
                      eventBus.$emit("switchTab", "chart-tab");
                    }
                  });
              }
            });
        }
      });
    },

    // In this function we call Api for stripe card listing
    cardListing() {
      let data = {
        company_id: this.getSelectedCompany.id,
      };
      this.$store.dispatch("cardListing", data).then((response) => {});
    },
  },
};
</script>

<style>
.rounded-card {
  border-radius: 50px;
}
.spanClass {
  font-size: 15px;
  text-align: center !important;
}
.card-setting {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}
.card-title {
  font-size: 30px;
  padding: 25px 15px 15px 15px;
}
.mastercard {
  background-color: #2b006f;
}
.jcb {
  background-color: #2662d6;
}
.visa {
  background-color: #2662d6;
}
.discover {
  background-color: #2662d6;
}
.diners {
  background-color: #2662d6;
}
.capital_one {
  background-color: #2662d6;
}
.citi {
  background-color: #2662d6;
}
.amex {
  background-color: #086fcf;
}
.unionpay {
  background-color: #2662d6;
}
.ImgHeader {
  font-size: 13px;
  color: white;

  background-color: #2662d6;
}
</style>
